import { call, put, takeEvery, all, fork } from "redux-saga/effects";

// Crypto Redux States
import {
    GET_CHARTS_DATA,
    GET_DONUT_CHART,
    GET_STACKED_DATA,
    GET_TOTAL_E_DOCUMENT,
    GET_TOTAL_NOTIFICATION
} from "./actionTypes";
import {
    apiSuccess,
    apiFail,
    getDonutChartSuccess,
    getDonutChartFail,
    getTotalEDocumentSuccess,
    getTotalEDocumentFail,
    getTotalNotificationSuccess,
    getTotalNotificationFail, getStackedDataSuccess, getStackedDataFail
} from "./actions";

//Include Both Helper File with needed methods
import {
    getWeeklyData,
    getYearlyData,
    getMonthlyData
}
    from "../../helpers/fakebackend_helper";
import dashboardService from "../../services/DashBoardService";

function* getChartsData({ payload: periodType }) {
    try {
        var response;
        if (periodType == "monthly") {
            response = yield call(getWeeklyData, periodType);
        }
        if (periodType == "yearly") {
            response = yield call(getYearlyData, periodType);
        }
        if (periodType == "weekly") {
            response = yield call(getMonthlyData, periodType);
        }

        yield put(apiSuccess(GET_CHARTS_DATA, response));
    } catch (error) {
        yield put(apiFail(GET_CHARTS_DATA, error));
    }
}

export function* watchGetChartsData() {
    yield takeEvery(GET_CHARTS_DATA, getChartsData);
}

export function *fetchTotalDoc(){
    yield takeEvery(GET_TOTAL_E_DOCUMENT, function* () {
        try {
            const docTotal = yield call(
                dashboardService.getTotalDocs
            );
            yield put(getTotalEDocumentSuccess(docTotal));
        } catch (error) {
            yield put(getTotalEDocumentFail());
        }
    });
}

export function *fetchTotalDonut(){
    yield takeEvery(GET_DONUT_CHART, function* () {
        try {
            const totalDonut = yield call(
                dashboardService.getDonutChart
            );
            yield put(getDonutChartSuccess(totalDonut));
        } catch (error) {
            yield put(getDonutChartFail());
        }
    });
}

export function *fetchTotalNotification(){
    yield takeEvery(GET_TOTAL_NOTIFICATION, function* () {
        try {
            const totalNotify = yield call(
                dashboardService.getTotalNotify
            );
            yield put(getTotalNotificationSuccess(totalNotify));
        } catch (error) {
            yield put(getTotalNotificationFail());
        }
    });
}

export function *fetchStackedData(){
    yield takeEvery(GET_STACKED_DATA, function* () {
        try {
            const stackedData = yield call(
                dashboardService.getStackedData
            );
            yield put(getStackedDataSuccess(stackedData));
        } catch (error) {
            yield put(getStackedDataFail());
        }
    });
}

function* dashboardSaga() {
    yield all([
        fork(watchGetChartsData),
        fork(fetchTotalDoc),
        fork(fetchTotalDonut),
        fork(fetchTotalNotification),
        fork(fetchStackedData)
    ]);
}

export default dashboardSaga;
